import { H2, LoadingIndicator } from '@triumph/design-system';

import { usePermissions } from '@/components/providers/PermissionsContextProvider';
import { CenteredContainer } from '@/components/router/PageRouter.StyledComponents';
import { Feature } from '@/components/shared/constants/features';

import { EmailTemplatePreview } from './EmailTemplatePreview';

export const EmailTemplatePreviewPage = () => {
    const { hasFeature, isLoading, isServerOutage } = usePermissions();

    if (isLoading) {
        return (
            <CenteredContainer>
                <LoadingIndicator show />
            </CenteredContainer>
        );
    }

    if (hasFeature(Feature.DebugMenu)) {
        return <EmailTemplatePreview />;
    }

    if (isServerOutage) {
        return (
            <CenteredContainer>
                <H2>We can't reach the server right now. Please refresh to try again.</H2>
            </CenteredContainer>
        );
    }

    return (
        <CenteredContainer>
            <H2>You don't have access to this page</H2>
        </CenteredContainer>
    );
};
